import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// import Policy from "../pages/policy";

export default function Footer() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className="footer">
      <div className="footer-menu">
        <ul className="footer-ul">
          <li>
            <p className="works-btn">
              <a href="#works">Works</a>
            </p>
          </li>
          <li>
            <p className="members-btn">
              <a href="#members">Members</a>
            </p>
          </li>
          <li>
            <p>
              <Button
                variant="primary"
                onClick={handleShow}
                className="policy-btn"
              >
                Privacy Policy
              </Button>
            </p>
          </li>
        </ul>
      </div>
      <p className="copyright">
        Copyrights ©︎lyonesse,Inc. 2022 All rights reserved.
      </p>

      <Modal
        show={show}
        onHide={handleClose}
        className="policy-modal policy-body"
      >
        <Modal.Header className="modal-text1">
          <Modal.Title>個人情報保護方針</Modal.Title>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-text1">
            <p>
              株式会社リオネス（以降、「当社」）は、このWebサイトをご利用になるお客様のプライバシーを尊重することをお約束します。Webサイトを参照しただけでは、お客様の個人情報が収集されることはありません。
            </p>
            <p>
              当社では、お客様が投稿される「お問合せ」をはじめ、氏名や電話番号、メールアドレスのような個人を特定できる情報（個人情報）の入力をお願いする場合があります。このような個人情報を以下の基準に従って管理し保護に努めます。プライバシーポリシーはインターネット上で当社のサービスを利用しているときに適応されます。
            </p>
            <br />
            <p>
              1.
              当社は、このWebサイトで入力された個人情報については、合理的な技術的施策をとることにより、個人情報への不正な侵入、個人情報の紛失、改ざん、漏えいなどの危険防止に努めます。
            </p>
            <p>
              2.
              当社は、お客様からご提供いただいた個人情報を、より良い製品・サービスを開発するため、お客様へ有用な情報をお届けするため、その他の正当な目的のためのみに使用いたします。
            </p>
            <p>
              3.
              当社は、お客様の個人情報の保護に関係する日本の法令その他の規範を遵守するとともに、本ポリシーの内容を継続的に見直し、その改善に努めます。
            </p>
            <p>
              4.
              当社は、お客様に無断で個人情報を収集し第三者に開示することはありません。もっとも、特定電気通信役務提供者の損害賠償責任の制限及び発信者情報の開示に関する法律によるなど、法的な根拠が認められる場合はこの限りではありません。
            </p>
            <p>
              5.
              当社のWebサイトでは、Cookieの情報を使って個々のお客様ごとにカスタマイズしたサービスを提供したりアクセス数の集計を行ったりします。尚、個人情報・入力情報をCookieに書き込むことは一切行なっておりません。
            </p>
            <p>
              6.
              このWebサイトよりリンクする第三者（リンク先）のインターネットサイトにおいて、閲覧者が提供する個人情報の取り扱いについては、当社は一切責任を負いません。各リンク先における個人情報の取り扱いに関する定め等をご覧ください。
            </p>
            <p>
              7.
              本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、お客様に通知することなく変更できるものとします。当社が別途定める場合を除いて、変更後のプライバシーポリシーは本Webサイトに掲載したときから効力を生じるものとします。
            </p>
            <br />
            <p>
              株式会社リオネス <br />
              東京都渋谷区恵比寿南2-8-2 キョウデンビル7F
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
}
